<script>
import {layoutComputed} from "@/state/helpers";
import MetisMenu from "metismenujs/dist/metismenujs";
import store from "@/state/store";
import {SimpleBar} from "simplebar-vue3";

/**
 * Sidebar component
 */
export default {
    mounted: function () {
        // eslint-disable-next-line no-unused-vars
        var menuRef = new MetisMenu("#side-menu");
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        const paths = [];

        for (var i = 0; i < links.length; i++) {
            paths.push(links[i]["pathname"]);
        }
        var itemIndex = paths.indexOf(window.location.pathname);
        if (itemIndex === -1) {
            const strIndex = window.location.pathname.lastIndexOf("/");
            const item = window.location.pathname.substr(0, strIndex).toString();
            matchingMenuItem = links[paths.indexOf(item)];
        } else {
            matchingMenuItem = links[itemIndex];
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");
            var parent = matchingMenuItem.parentElement;

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add("mm-active");
                const parent2 = parent.parentElement.closest("ul");
                if (parent2 && parent2.id !== "side-menu") {
                    parent2.classList.add("mm-show");

                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add("mm-active");
                        var childAnchor = parent3.querySelector(".has-arrow");
                        var childDropdown = parent3.querySelector(".has-dropdown");
                        if (childAnchor) childAnchor.classList.add("mm-active");
                        if (childDropdown) childDropdown.classList.add("mm-active");

                        const parent4 = parent3.parentElement;
                        if (parent4 && parent4.id !== "side-menu") {
                            parent4.classList.add("mm-show");
                            const parent5 = parent4.parentElement;
                            if (parent5 && parent5.id !== "side-menu") {
                                parent5.classList.add("mm-active");
                                const childanchor = parent5.querySelector(".is-parent");
                                if (childanchor && parent5.id !== "side-menu") {
                                    childanchor.classList.add("mm-active");
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    components: {
        SimpleBar,
    },
    props: {
        isCondensed: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...layoutComputed,
        scopeMenu() {
            let menu = [
                {
                    parent: 'system',
                    children: ['create-system', 'list-system', 'create-function', 'list-function']
                },
                {
                    parent: 'organization',
                    children: ['add-organization', 'list-organization']
                },
                {
                    parent: 'user',
                    children: ['list-user', 'add-user']
                },
                {
                    parent: 'brand',
                    children: ['list-brand']
                },
                {
                    parent: 'client',
                    children: ['list-client', 'add-client']
                },
                {
                    parent: 'group',
                    children: ['group-list', 'add-group']
                },
                {
                    parent: 'role',
                    children: ['role-list', 'add-role']
                },
                {
                    parent: 'scope',
                    children: ['add-scope', 'scope-list']
                },
            ]

            return menu;
        },
    },
    data() {
        return {
            settings: {
                minScrollbarLength: 60,
            },
        };
    },
    watch: {
        $route: {
            handler: "onRoutechange",
            immediate: true,
            deep: true,
        },
        type: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "default":
                            document.body.setAttribute("data-sidebar-size", "lg");
                            break;
                        case "compact":
                            document.body.setAttribute("data-sidebar-size", "md");
                            document.body.classList.remove("vertical-collpsed");
                            break;
                        case "icon":
                            document.body.setAttribute("data-sidebar-size", "sm");
                            break;
                        default:
                            document.body.setAttribute("data-sidebar-size", "lg");
                            break;
                    }
                }
            },
        },
        width: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "boxed":
                            document.body.setAttribute("data-layout-size", "boxed");
                            break;
                        case "fluid":
                            document.body.setAttribute("data-layout-size", "fluid");
                            break;
                        default:
                            document.body.setAttribute("data-layout-size", "fluid");
                            break;
                    }
                }
            },
        },
        color: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "light":
                            document.body.setAttribute("data-sidebar", "light");
                            break;
                        case "dark":
                            document.body.setAttribute("data-sidebar", "dark");
                            break;
                        case "brand":
                            document.body.setAttribute("data-sidebar", "brand");
                            break;
                        default:
                            document.body.setAttribute("data-sidebar", "dark");
                            break;
                    }
                }
            },
        },
    },
    methods: {
        onRoutechange() {
            setTimeout(() => {
                if (document.getElementsByClassName("mm-active").length > 0) {
                    const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
                    if (currentPosition > 500)
                        if (this.$refs.isSimplebar)
                            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
                }
            }, 300);
        },
        toggleMenu() {
            this.$parent.toggleMenu();
        },
        isShowMenu(parentMenu) {
            let childMenu = this.scopeMenu.find(s => s.parent === parentMenu).children;
            let scopes = store.state.auth.scopes;
            let isShow = false;
            for (let index = 0; index < childMenu.length; index++) {
                let element = childMenu[index];
                let sIndex = scopes.findIndex(s => s === element);
                if (sIndex !== -1) {
                    isShow = true;
                    break;
                }
            }
            return isShow;
        },
        isShowInScope(routeName) {
            let scopes = store.state.auth.scopes;
            let toName = routeName;
            let index = scopes.findIndex(s => s === toName);
            if (index === -1) {
                return false
            } else {
                return true
            }
        }
    },
};
</script>

<template>
    <!-- ========== Left Sidebar Start ========== -->
    <div class="vertical-menu">

        <!-- LOGO -->
        <div class="navbar-brand-box">
            <router-link to="/" class="logo logo-dark">
        <span class="logo-sm">
          <img src="@/assets/images/logo-dark-sm.png" alt="" height="22">
        </span>
                <span class="logo-lg">
          <img src="@/assets/images/logo-dark.png" alt="" height="22">
        </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
        <span class="logo-lg">
          <img src="@/assets/images/logo.svg" alt="" height="30">
        </span>
                <span class="logo-sm">
          <img src="@/assets/images/logo.svg" alt="" height="30">
        </span>
            </router-link>
        </div>

        <button type="button" class="btn btn-sm px-3 header-item vertical-menu-btn topnav-hamburger"
                @click="toggleMenu">
      <span class="hamburger-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
        </button>

        <SimpleBar data-simplebar class="sidebar-menu-scroll" ref="isSimplebar">

            <!--- Sidemenu -->
            <div id="sidebar-menu">
                <!-- Left Menu Start -->
                <ul class="metismenu list-unstyled" id="side-menu">
                    <li v-if="isShowMenu('system')" class="menu-title" data-key="t-menu">系統別管理</li>
                    <li v-if="isShowMenu('system')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="settings-2-outline"></eva-icon>
                            <span class="menu-item" data-key="t-store">系統別管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('list-system')" class="side-nav-link-ref"
                                             to="/system/list-system" data-key="t-add-upplier">系統別總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('create-system')" class="side-nav-link-ref"
                                             to="/system/create-system" data-key="t-add-upplier">新增系統別
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('list-function')" class="side-nav-link-ref"
                                             to="/system/list-function" data-key="t-add-upplier">功能總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('create-function')" class="side-nav-link-ref"
                                             to="/system/create-function" data-key="t-add-upplier">新增系統功能
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isShowMenu('organization')" class="menu-title" data-key="t-menu">組織管理</li>
                    <li v-if="isShowMenu('organization')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="briefcase-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">組織管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('list-organization')" class="side-nav-link-ref"
                                             to="/organization/list-organization" data-key="t-add-upplier">組織總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-organization')" class="side-nav-link-ref"
                                             to="/organization/add-organization" data-key="t-add-upplier">新增組織
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isShowMenu('brand')" class="menu-title" data-key="t-menu">品牌管理</li>
                    <li v-if="isShowMenu('brand')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="shopping-bag-outline"></eva-icon>
                            <span class="menu-item" data-key="t-brand">品牌管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('list-brand')" class="side-nav-link-ref"
                                             to="/brand/list-brand" data-key="t-list-brand">品牌總覽
                                </router-link>
                            </li>
                        </ul>
                    </li>


                    <li v-if="isShowMenu('client')" class="menu-title" data-key="t-menu">應用裝置管理</li>
                    <li v-if="isShowMenu('client')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="monitor-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">應用裝置管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('list-client')" class="side-nav-link-ref"
                                             to="/clients/list-client" data-key="t-add-client">應用裝置總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-client')" class="side-nav-link-ref"
                                             to="/clients/add-client" data-key="t-add-client">新增應用裝置
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isShowMenu('group')" class="menu-title" data-key="t-menu">裝置分組權限管理</li>
                    <li v-if="isShowMenu('group')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="keypad-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">裝置分組權限管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('group-list')" class="side-nav-link-ref"
                                             to="/groups/group-list" data-key="t-group-list">裝置分組權限總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-group')" class="side-nav-link-ref"
                                             to="/groups/add-group" data-key="t-add-group">新增裝置分組權限
                                </router-link>
                            </li>
                        </ul>
                    </li>


                    <li v-if="isShowMenu('user')" class="menu-title" data-key="t-menu">使用者管理</li>
                    <li v-if="isShowMenu('user')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="person-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">使用者管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('list-user')" class="side-nav-link-ref"
                                             to="/operator/list-user" data-key="t-add-upplier">使用者總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-user')" class="side-nav-link-ref"
                                             to="/operator/add-user" data-key="t-add-upplier">新增使用者
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isShowMenu('role')" class="menu-title" data-key="t-menu">角色管理</li>
                    <li v-if="isShowMenu('role')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="award-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">角色管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('role-list')" class="side-nav-link-ref"
                                             to="/roles/role-list" data-key="t-add-upplier">角色總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-role')" class="side-nav-link-ref"
                                             to="/roles/add-role" data-key="t-add-upplier">新增角色
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isShowMenu('scope')" class="menu-title" data-key="t-menu">權限管理</li>
                    <li v-if="isShowMenu('scope')">
                        <a href="javascript: void(0);" class="has-arrow">
                            <eva-icon class="icon nav-icon" name="lock-outline"></eva-icon>
                            <span class="menu-item" data-key="t-user">權限管理</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li>
                                <router-link v-if="isShowInScope('scope-list')" class="side-nav-link-ref"
                                             to="/scopes/scope-list" data-key="t-add-upplier">權限總覽
                                </router-link>
                            </li>
                            <li>
                                <router-link v-if="isShowInScope('add-scope')" class="side-nav-link-ref"
                                             to="/scopes/add-scope" data-key="t-add-upplier">新增權限
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- Sidebar -->

            <div class="p-3 px-4 sidebar-footer">
                <p class="mb-1 main-title">{{ new Date().getFullYear() }} &copy; Weshaire</p>
                <p class="mb-0">Design & Develop by Weshaire</p>
            </div>
        </SimpleBar>
    </div>
    <!-- Left Sidebar End -->
</template>
